const squareWalls = {

    walls: [
        // left
        {
            x: '-5%',
            y: '-5%',
            width: '5%',
            height: '105%',
        },
        // right
        {
            x: '100%',
            y: '-5%',
            width: '5%',
            height: '105%',
        },
        // top
        {
            x: '0%',
            y: '-5%',
            width: '105%',
            height: '5%',
        },
        // bottom
        {
            x: '-5%',
            y: '99%',
            width: '105%',
            height: '5%',
        },
    ],

};

export default squareWalls;



// WEBPACK FOOTER //
// ./js/flux/partials/squareWalls.js